import React from "react";

const Loader: React.FC = () => {
  return (
    <div className="pulse-loader">
      <div className="dot" style={{ backgroundColor: "#0A3D91" }}></div>
      <div className="dot" style={{ backgroundColor: "#00AEEF" }}></div>
      <div className="dot" style={{ backgroundColor: "#2E7D32" }}></div>
    </div>
  );
};

export default Loader;
